import React from "react";
import { cn } from "@/utils/utils";

type CounterBadgeSize = "sm" | "lg";

/** `notification` is the solid blue count of unread items on a tab. */
type CounterBadgeVariant = "default" | "notification";

interface CounterBadgeProps {
  count: number;
  size?: CounterBadgeSize;
  variant?: CounterBadgeVariant;
  className?: string;
}

const CounterBadge: React.FC<CounterBadgeProps> = ({
  count,
  size = "sm",
  variant = "default",
  className
}) => {
  const isNotification = variant === "notification";
  const sizeClasses = {
    sm: {
      container: "min-w-5 h-5",
      text: "text-sm font-normal"
    },
    lg: {
      container: "min-w-6 h-6",
      text: "text-base font-normal"
    }
  };

  const sizeConfig = sizeClasses[size];

  return (
    <div
      className={cn(
        "flex items-center justify-center w-fit",
        "px-0.5 py-0.5",
        "gap-1",
        isNotification
          ? "bg-badges-counter-notification"
          : "border-[0.5px] border-badge-default bg-badges-default",
        "rounded-md",
        sizeConfig.container,
        "transition-all duration-200 ease-in-out",
        className
      )}
    >
      <p
        className={cn(
          sizeConfig.text,
          isNotification
            ? "font-semibold leading-[18px] text-on-surface"
            : "text-secondary"
        )}
      >
        {count}
      </p>
    </div>
  );
};

export default CounterBadge;
